<div
    [id]="composedId + '_metadata'"
    [class]="'agpr-metadata' + (mediaType ? ' agpr-metadata-' + mediaType : '')"
    [ngClass]="{
        'agpr-metadata-sentiment-positive': type === attributeTypes.sentiment && value === 'Sentiment.' + sentimentTypes.positive,
        'agpr-metadata-sentiment-negative': type === attributeTypes.sentiment && value === 'Sentiment.' + sentimentTypes.negative,
        'agpr-metadata-sentiment-neutral': type === attributeTypes.sentiment && value === 'Sentiment.' + sentimentTypes.neutral,
        'agpr-metadata-sentiment-not-available': type === attributeTypes.sentiment && value === 'Sentiment.' + sentimentTypes.notAvailable,
        'agpr-metadata-multiline': isMultiline,
    }"
>

    @switch (type) {
        @case (attributeTypes.sentiment) {
            <div
                [id]="composedId + '_metadata_content'"
                class="agpr-metadata-content"
                [class.agpr-metadata-content--withInfoIcon]="infoTooltip"
                [agprTooltip]="tooltip"
                [tooltipPosition]="tooltipPosition"
                [useTooltipAsAriaLabel]="false"
                [attr.aria-label]="ariaLabel || ((tooltip | localize) + ': ' + ((value !== undefined && value !== null && value !== ('Sentiment.' + sentimentTypes.notAvailable)) ? (value | localize) : ('notAvailable' | localize)))"
                [escape]="false"
                role="img"
            >
                <div
                    [id]="composedId + '_metadata_content_icon'"
                    class="agpr-metadata-iconWrapper"
                >
                    @switch (value) {
                        @case ('Sentiment.' + sentimentTypes.positive) {
                            <span class="agpr-metadata-icon" [ngClass]="'fa-solid fa-face-smile'" role="img"></span>
                        }
                        @case ('Sentiment.' + sentimentTypes.negative) {
                            <span class="agpr-metadata-icon" [ngClass]="'fa-solid fa-face-frown-slight'" role="img"></span>
                        }
                        @case ('Sentiment.' + sentimentTypes.neutral) {
                            <span class="agpr-metadata-icon" [ngClass]="'fa-solid fa-face-meh'" role="img"></span>
                        }
                        @case ('Sentiment.' + sentimentTypes.notAvailable) {
                            <span class="agpr-metadata-icon" [ngClass]="'fa-solid fa-face-meh-blank'" role="img"></span>
                        }
                    }
                </div>
                <span
                    [id]="composedId + '_metadata_content_label'"
                    class="agpr-metadata-label"
                >
                    {{ (value !== undefined && value !== null && value !== ('Sentiment.' + sentimentTypes.notAvailable)) ? (value | localize) : ('na' | localize) }}
                </span>
            </div>
        }
        @case (attributeTypes.audienceReach) {
            <div class="agpr-metadata-content">
                <div
                    [id]="composedId + '_metadata_content'"
                    class="agpr-metadata-content--inner"
                    [agprTooltip]="tooltip"
                    [tooltipPosition]="tooltipPosition"
                    [useTooltipAsAriaLabel]="false"
                    [attr.aria-label]="ariaLabel || ((tooltip | localize) + ': ' + ((value || value === 0) ? (value | number) : ('notAvailable' | localize)))"
                    [escape]="false"
                    role="img"
                    [agprInitiallyFocusable]="initiallyFocusable"
                >
                    <div
                        [id]="composedId + '_metadata_content_icon'"
                        class="agpr-metadata-iconWrapper"
                    >
                        <span
                            class="agpr-metadata-icon"
                            [ngClass]="icon"
                            role="img"
                        ></span>
                    </div>
                    <span
                        [id]="composedId + '_metadata_content_label'"
                        class="agpr-metadata-label"
                    >
                        {{ (value || value === 0) ? (value | number) : ('na' | localize) }}
                    </span>
                </div>

                @if (isSimilarWeb) {
                    <a
                        class="agpr-metadata-link"
                        target="_blank"
                        href="http://www.similarweb.com/"
                        [agprTooltip]="similarwebTooltip"
                        [escape]="false"
                        [agprInitiallyFocusable]="initiallyFocusable"
                    >
                        <img
                            [src]="appBaseHref + 'assets/images/SimilarWeb-logo.svg'"
                            [alt]="'Common.audienceReach.similarWeb' | localize"
                            height="18"
                        />
                    </a>
                }
            </div>
        }
        @case (attributeTypes.domainAuthority) {
            <div
                [id]="composedId + '_metadata_content'"
                class="agpr-metadata-content agpr-metadata-content--withInfoIcon"
                [agprTooltip]="tooltip"
                [tooltipPosition]="tooltipPosition"
                [useTooltipAsAriaLabel]="false"
                [attr.aria-label]="ariaLabel || ((tooltip | localize) + ': ' + ((value || value === 0) ? (value | number) : ('notAvailable' | localize)))"
                [escape]="false"
                role="img"
            >
                <div
                    [id]="composedId + '_metadata_content_icon'"
                    class="agpr-metadata-iconWrapper"
                >
                    <span class="agpr-metadata-icon" [ngClass]="icon" role="img"></span>
                </div>
                <span
                    [id]="composedId + '_metadata_content_label'"
                    class="agpr-metadata-label"
                >
                    {{ (value || value === 0) ? (value | number) : ('na' | localize) }}
                </span>
                <a
                    class="agpr-metadata-link"
                    target="_blank"
                    href="https://moz.com"
                >
                    <img
                        [src]="appBaseHref + 'assets/images/moz-logo.svg'"
                        [alt]="'Common.domainAuthority.moz' | localize"
                        height="12"
                    />
                </a>
            </div>
        }
        @case (attributeTypes.url) {
            <div
                [id]="composedId + '_metadata_content'"
                class="agpr-metadata-content agpr-metadata-content--withButton"
                [agprTooltip]="tooltip"
                [tooltipPosition]="tooltipPosition"
                [useTooltipAsAriaLabel]="false"
                [attr.aria-label]="ariaLabel || ((tooltip | localize) + ': ' + (value || ('notAvailable' | localize)))"
                [escape]="false"
                role="img"
            >
                <div
                    [id]="composedId + '_metadata_content_icon'"
                    class="agpr-metadata-iconWrapper"
                >
                    <span class="agpr-metadata-icon" [ngClass]="icon" role="img"></span>
                </div>
                <a
                    class="agpr-metadata-label agpr-metadata-linkLabel agpr-link"
                    target="_blank"
                    [href]="value"
                >
                    <span [id]="composedId + '_metadata_content_label'">
                        {{ value || ('na' | localize) }}
                    </span>
                </a>
            </div>
        }
        @case (attributeTypes.adValueUsd) {
            <div
                [id]="composedId + '_metadata_content'"
                class="agpr-metadata-content agpr-metadata-content--withInfoIcon"
                [agprTooltip]="tooltip"
                [tooltipPosition]="tooltipPosition"
                [useTooltipAsAriaLabel]="false"
                [attr.aria-label]="ariaLabel || ((tooltip | localize) + ': ' + ((value || value === 0) ? (value | CurrencyConversion) : ('notAvailable' | localize)))"
                [escape]="false"
                role="img"
            >
                <div
                    [id]="composedId + '_metadata_content_icon'"
                    class="agpr-metadata-iconWrapper"
                >
                    <span class="agpr-metadata-icon" [ngClass]="icon" role="img"></span>
                </div>
                <span
                    [id]="composedId + '_metadata_content_label'"
                    class="agpr-metadata-label"
                >
                    {{ (value || value === 0) ? (value | CurrencyConversion) : ('na' | localize) }}
                </span>
            </div>
        }
        @case (attributeTypes.wordCount) {
            <div
                [id]="composedId + '_metadata_content'"
                class="agpr-metadata-content"
                [agprTooltip]="tooltip"
                [tooltipPosition]="tooltipPosition"
                [useTooltipAsAriaLabel]="false"
                [attr.aria-label]="ariaLabel || ((tooltip | localize) + ': ' + ((value || value === 0) ? (value | number) : ('notAvailable' | localize)))"
                [escape]="false"
                role="img"
            >
                <div
                    [id]="composedId + '_metadata_content_icon'"
                    class="agpr-metadata-iconWrapper"
                >
                    <span class="agpr-metadata-icon" [ngClass]="icon" role="img"></span>
                </div>
                <span
                    [id]="composedId + '_metadata_content_label'"
                    class="agpr-metadata-label"
                >
                    {{ (value || value === 0) ? (value | number) : ('na' | localize) }}
                </span>
            </div>
        }
        @case (attributeTypes.duration) {
            <div
                [id]="composedId + '_metadata_content'"
                class="agpr-metadata-content"
                [agprTooltip]="tooltip"
                [tooltipPosition]="tooltipPosition"
                [useTooltipAsAriaLabel]="false"
                [attr.aria-label]="ariaLabel || ((tooltip | localize) + ': ' + ((value || value === 0) ? (value * 1000 | date: 'mm:ss' : 'UTC') : ('notAvailable' | localize)))"
                [escape]="false"
                role="img"
            >
                <div
                    [id]="composedId + '_metadata_content_icon'"
                    class="agpr-metadata-iconWrapper"
                >
                    <span class="agpr-metadata-icon" [ngClass]="icon" role="img"></span>
                </div>
                <span
                    [id]="composedId + '_metadata_content_label'"
                    class="agpr-metadata-label"
                >
                    {{ (value || value === 0) ? (value * 1000 | date: 'mm:ss' : 'UTC') : ('na' | localize) }}
                </span>
            </div>
        }
        @case (attributeTypes.language) {
            <div
                [id]="composedId + '_metadata_content'"
                class="agpr-metadata-content"
                [agprTooltip]="tooltip"
                [tooltipPosition]="tooltipPosition"
                [useTooltipAsAriaLabel]="false"
                [attr.aria-label]="ariaLabel || ((tooltip | localize) + ': ' + (value ? ('Language.' + value | localize) : ('notAvailable' | localize)))"
                [escape]="false"
                role="img"
            >
                <div
                    [id]="composedId + '_metadata_content_icon'"
                    class="agpr-metadata-iconWrapper"
                >
                    <span class="agpr-metadata-icon" [ngClass]="icon" role="img"></span>
                </div>
                <span
                    [id]="composedId + '_metadata_content_label'"
                    class="agpr-metadata-label"
                >
                    @if (value) {
                        @for (val of value.split(','); track val; let last = $last) {
                            {{ 'Language.' + val.trim() | localize }}
                            @if (!last) {, }
                        }
                    } @else {
                        <ng-template>{{ 'na' | localize }}</ng-template>
                    }
                </span>
            </div>
        }
        @default {
            <div
                [id]="composedId + '_metadata_content'"
                class="agpr-metadata-content"
                [ngClass]="{
                    'agpr-metadata-content--withButton': showCopyIcon
                }"
                [agprTooltip]="tooltip"
                [tooltipPosition]="tooltipPosition"
                [useTooltipAsAriaLabel]="false"
                [attr.aria-label]="ariaLabel || ((tooltip | localize) + ': ' + ((value !== undefined && value !== null) ? (value | localize) : ('notAvailable' | localize)))"
                [escape]="false"
                role="img"
                [agprInitiallyFocusable]="initiallyFocusable"
            >
                <div
                    [id]="composedId + '_metadata_content_icon'"
                    class="agpr-metadata-iconWrapper"
                >
                    <span class="agpr-metadata-icon" [ngClass]="icon" role="img"></span>
                </div>
                <span
                    [id]="composedId + '_metadata_content_label'"
                    class="agpr-metadata-label"
                >
                    {{ (value !== undefined && value !== null) ? (value | localize) : ('na' | localize) }}
                </span>
                <ng-content></ng-content>
            </div>
        }
    }

    @if (showCopyIcon) {
        <agpr-button
            [id]="composedId + '_copy'"
            [style]="buttonTypes.icon"
            icon="fa-kit-duotone fa-agpr-copy"
            [tooltip]="'Common.meta.copy.button' | localize: { name: copyToolTip ||  tooltip }"
            [tooltipPosition]="tooltipPosition"
            (click)="copy($event, copyValue || value )"
        ></agpr-button>
    }

    @if (infoTooltip) {
        <span
            [id]="composedId + '_metadata_content_infoTooltip'"
            class="agpr-infoIconStyle fa-regular fa-circle-info"
            [agprTooltip]="infoTooltip"
            [tooltipPosition]="tooltipPosition"
            role="img"
        ></span>
    }
</div>
